import React, { MouseEventHandler, PropsWithChildren } from 'react';
import theme from './SettingsSection.module.scss';
import { classnames } from '@/utils/html';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusCircle } from '@fortawesome/pro-light-svg-icons';

interface SettingsSectionListAddButtonProps extends PropsWithChildren {
    onClick?: MouseEventHandler<HTMLLIElement>;
    active: boolean;
    disabled?: boolean;
}

const SettingsSectionListAddButton: React.FC<SettingsSectionListAddButtonProps> = ({
    onClick,
    children,
    active,
    disabled,
}) => {
    return (
        <li
            className={classnames(theme.addButton, {
                [theme.active]: active,
                [theme.disabled]: disabled,
            })}
            onClick={disabled ? undefined : onClick}>
            <FontAwesomeIcon icon={faPlusCircle} />
            {children}
        </li>
    );
};

export default SettingsSectionListAddButton;
